// import React, { useState, useRef, useEffect } from 'react';
// import {
//   Button,
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Container,
//   Grid,
//   CircularProgress,
//   Chip,
//   Divider,
//   Fade,
//   Grow,
//   Tooltip,
//   IconButton,
//   Alert,
//   Snackbar,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   FormHelperText
// } from '@mui/material';
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileOpenIcon from '@mui/icons-material/FileOpen';
// import InfoIcon from '@mui/icons-material/Info';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import SendIcon from '@mui/icons-material/Send';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import DownloadIcon from '@mui/icons-material/Download';
// import * as XLSX from 'xlsx';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import Header from '../Header';
// import { local_signage, local_url, web_hook } from '../Const';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#f50057',
//     },
//     background: {
//       default: '#f5f7fa',
//     },
//   },
//   typography: {
//     h4: {
//       fontWeight: 600,
//     },
//     button: {
//       fontWeight: 500,
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           padding: '10px 24px',
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           backgroundColor: '#f0f5ff',
//           fontWeight: 'bold',
//         },
//       },
//     },
//   },
// });

// export const HorecaUpload = () => {
//   const [file, setFile] = useState(null);
//   const [fileName, setFileName] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const [excelData, setExcelData] = useState([]);
//   const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
//   const [validatedData, setValidatedData] = useState(null);
//   const [invalidRows, setInvalidRows] = useState([]);
//   const [duplicateRows, setDuplicateRows] = useState([]);
//   const [rateErrorRows, setRateErrorRows] = useState([]);
//   const token = localStorage.getItem('AuthorizationToken');
//   const fileInputRef = useRef(null);
//   const [invalidRowsList, setInvalidRowsList] = useState([]);
//   const [apiErrors, setApiErrors] = useState([]);
//   const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
//   const [excelColumns, setExcelColumns] = useState([]);

//   // New state for SF Areas
//   const [areas, setAreas] = useState([]);
//   const [areaCodeToIdMap, setAreaCodeToIdMap] = useState({});
//   const [selectedArea, setSelectedArea] = useState('');
//   const [isLoadingAreas, setIsLoadingAreas] = useState(false);
//   const [areaError, setAreaError] = useState('');

//   // New state for grouped data by area
//   const [groupedDataByArea, setGroupedDataByArea] = useState({});

//   // New state for bulk rates
//   const [bulkRates, setBulkRates] = useState([]);
//   const [isFetchingBulkRates, setIsFetchingBulkRates] = useState(false);

//   // Fetch SF Areas on component mount
//   useEffect(() => {
//     if (token) {
//       fetchAreas();
//       fetchBulkRates();
//     } else {
//       setNotification({
//         open: true,
//         message: 'No authorization token found. Please login first.',
//         severity: 'error'
//       });
//     }
//   }, [token]);

//   const fetchAreas = async () => {
//     setIsLoadingAreas(true);
//     setAreaError('');

//     try {
//       const userId = localStorage.getItem('userId') || 'UnknownUser';

//       const response = await fetch(`${local_url}/api/SFArea/${userId}`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch areas: ${response.status}`);
//       }

//       const data = await response.json();
//       setAreas(data.map(area => ({
//         AreaId: area.sfAreaId,
//         AreaName: area.sfAreaName,
//         AreaCode: area.areaCode
//       })));

//       // Create a mapping from area code to sfAreaId for lookup
//       const codeToIdMapping = {};
//       data.forEach(area => {
//         codeToIdMapping[area.areaCode] = area.sfAreaId;
//       });
//       setAreaCodeToIdMap(codeToIdMapping);

//       console.log(`Successfully loaded ${data.length} areas in background`, codeToIdMapping);
//     } catch (error) {
//       console.error('Error fetching areas:', error);
//       setAreaError('Failed to load areas. Please refresh the page or contact support.');
//     } finally {
//       setIsLoadingAreas(false);
//     }
//   };

//   const fetchBulkRates = async () => {
//     setIsFetchingBulkRates(true);

//     try {
//       const response = await fetch('https://retailuat.abisibg.com/api/v1/getjsonbulkrates', {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch bulk rates: ${response.status}`);
//       }

//       const data = await response.json();
//       setBulkRates(data);

//       console.log('Successfully loaded bulk rates in background:', data);
//     } catch (error) {
//       console.error('Error fetching bulk rates:', error);
//       // Don't show error notification - this is a background operation
//       // You can log errors to console for debugging
//     } finally {
//       setIsFetchingBulkRates(false);
//     }
//   };

//   // Helper function to get QualifyQty from bulk rates
//   const getQualifyQty = (itemCode, areaCode, rateType) => {
//     if (!bulkRates || !bulkRates.RateSchemeUpdate) return '-';

//     // Convert area code to area ID using the map
//     const areaId = areaCodeToIdMap[String(areaCode)];
//     if (!areaId) return '-';

//     for (const parentItem of bulkRates.RateSchemeUpdate) {
//       if (parentItem.childlist) {
//         for (const childItem of parentItem.childlist) {
//           if (String(childItem.ChildItemId) === String(itemCode)) {
//             if (childItem.rates) {
//               for (const rate of childItem.rates) {
//                 if (rate.AreaId === areaId && rate.BulkRateType === rateType) {
//                   return rate.QualifyQty;
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//     return '-';
//   };

//   // Helper function to get ItemName (chlidname) from bulk rates API
//   const getItemName = (itemCode) => {
//     if (!bulkRates || !bulkRates.RateSchemeUpdate) return '-';

//     for (const parentItem of bulkRates.RateSchemeUpdate) {
//       if (parentItem.childlist) {
//         for (const childItem of parentItem.childlist) {
//           if (String(childItem.ChildItemId) === String(itemCode)) {
//             return childItem.chlidname || '-';
//           }
//         }
//       }
//     }
//     return '-';
//   };

//   const handleAreaChange = (event) => {
//     setSelectedArea(event.target.value);
//   };

//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//       setValidatedData(null);
//       setInvalidRows([]);
//       setDuplicateRows([]);
//       setRateErrorRows([]);
//       setNotification({
//         open: true,
//         message: `File "${selectedFile.name}" selected successfully`,
//         severity: 'success'
//       });
//     }
//   };

//   const handleImport = () => {
//     if (!file) {
//       setNotification({
//         open: true,
//         message: 'Please select a file first',
//         severity: 'warning'
//       });
//       return;
//     }

//     if (isLoadingAreas) {
//       setNotification({
//         open: true,
//         message: 'Please wait for area information to load before importing',
//         severity: 'warning'
//       });
//       return;
//     }

//     if (areas.length === 0) {
//       setNotification({
//         open: true,
//         message: 'No valid areas found. Please refresh the page or contact support.',
//         severity: 'error'
//       });
//       return;
//     }

//     setIsLoading(true);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//     console.log('Import button pressed. File:', file.name);

//     // Read the Excel file
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[firstSheetName];

//         // Convert Excel data to JSON
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);

//         // Check if data exists
//         if (jsonData.length === 0) {
//           setNotification({
//             open: true,
//             message: 'No data found in the Excel file',
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }

//         // Extract headers from the first row
//         const headers = Object.keys(jsonData[0]);
//         setExcelColumns(headers);

//         // Check for required columns - AreaCode should be first column
//         const requiredColumns = ['AreaCode', 'ItemCode'];
//         const rateTypeColumns = ['RegularRate', 'BulkRate', 'VolumeRate'];

//         const missingBasicColumns = requiredColumns.filter(col =>
//           !headers.some(header => header.toLowerCase() === col.toLowerCase())
//         );

//         if (missingBasicColumns.length > 0) {
//           setNotification({
//             open: true,
//             message: `Missing required columns: ${missingBasicColumns.join(', ')}`,
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }

//         // Check if at least one rate type column exists
//         const hasRateTypeColumns = rateTypeColumns.some(col =>
//           headers.some(header => header.toLowerCase() === col.toLowerCase())
//         );

//         if (!hasRateTypeColumns) {
//           setNotification({
//             open: true,
//             message: 'At least one of these columns is required: RegularRate, BulkRate, VolumeRate',
//             severity: 'error'
//           });
//           setIsLoading(false);
//           return;
//         }

//         // If we reach here, proceed with validation
//         processExcelData(jsonData);

//       } catch (error) {
//         console.error('Error parsing Excel file:', error);
//         setNotification({
//           open: true,
//           message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
//           severity: 'error'
//         });
//         setIsLoading(false);
//       }
//     };

//     reader.onerror = () => {
//       setIsLoading(false);
//       setNotification({
//         open: true,
//         message: 'Error reading file',
//         severity: 'error'
//       });
//     };

//     reader.readAsArrayBuffer(file);
//   };

//   const processExcelData = (jsonData) => {
//     setIsLoading(true);

//     // Track invalid rows and duplicate combinations
//     const invalidRowsList = [];
//     const duplicateRowsList = [];
//     const dataByAreaAndType = {}; // Structure: { areaId: { 'R1': [], 'B1': [], 'V1': [] } }
//     const rateTypeCombinations = new Map(); // Track duplicates

//     // Rate type mappings
//     const rateTypeMap = {
//       'RegularRate': { type: '1R', code: 'Regular' },
//       'BulkRate': { type: '2B', code: 'Bulk' },
//       'VolumeRate': { type: '3V', code: 'Volume' }
//     };

//     // Validate data types and business rules
//     const validData = jsonData.map((row, index) => {
//       // Define specific error types for more detailed reporting
//       const errors = [];
//       let sfAreaId = '';
//       const processedRates = [];

//       // Check for AreaCode
//       if (!row.AreaCode || row.AreaCode === '') {
//         errors.push('missing_areacode');
//       } else {
//         // Validate AreaCode against available areas from API
//         const validAreaCodes = Object.keys(areaCodeToIdMap);
//         if (!validAreaCodes.includes(String(row.AreaCode))) {
//           errors.push('invalid_areacode');
//         } else {
//           // Convert AreaCode to sfAreaId
//           sfAreaId = areaCodeToIdMap[String(row.AreaCode)];
//         }
//       }

//       // Check for empty values
//       if (!row.ItemCode || row.ItemCode === '') {
//         errors.push('missing_identifier');
//       }

//       // Process each rate type
//       for (const [rateColumn, rateInfo] of Object.entries(rateTypeMap)) {
//         const rateValue = row[rateColumn];

//         // Only process if the column has a value
//         if (rateValue !== undefined && rateValue !== null && rateValue !== '') {
//           const rate = Number(rateValue);

//           // Validate rate
//           if (rate < 0) {
//             errors.push('negative_value');
//           }

//           // Check for more than two decimal places
//           if (String(rateValue).includes('.') && String(rateValue).split('.')[1].length > 2) {
//             errors.push('invalid_decimals');
//           }

//           // Check for double decimal points
//           if (String(rateValue).split('.').length > 2) {
//             errors.push('double_decimal');
//           }

//           // Check for non-numeric rates
//           if (isNaN(rate)) {
//             errors.push('non_numeric_value');
//           }

//           if (!isNaN(rate)) {
//             processedRates.push({
//               rateType: rateInfo.type,
//               rateColumn: rateColumn,
//               rate: rate
//             });
//           }
//         }
//       }

//       // Check for special characters in ItemCode
//       if (row.ItemCode && /[^a-zA-Z0-9-_]/.test(row.ItemCode)) {
//         errors.push('special_chars');
//       }

//       // Check if ItemCode exists in bulk rates (item mapping validation)
//       if (row.ItemCode && !errors.includes('missing_identifier') && processedRates.length > 0) {
//         const itemExists = bulkRates && bulkRates.RateSchemeUpdate && bulkRates.RateSchemeUpdate.some(
//           parentItem => parentItem.childlist && parentItem.childlist.some(
//             childItem => String(childItem.ChildItemId) === String(row.ItemCode)
//           )
//         );
//         if (!itemExists) {
//           errors.push('item_not_mapped');
//         }
//       }

//       // Store error information for this row
//       if (errors.length > 0) {
//         invalidRowsList.push({
//           rowNumber: index + 1,
//           errors: errors
//         });
//       }

//       // Check for duplicates per rate type
//       processedRates.forEach(rateInfo => {
//         const key = `${sfAreaId}-${row.ItemCode}-${rateInfo.rateType}`;
//         if (rateTypeCombinations.has(key)) {
//           duplicateRowsList.push(index + 1);
//         } else {
//           rateTypeCombinations.set(key, true);
//         }
//       });

//       // Group data by Area with RateType included in each item
//       if (sfAreaId && !errors.length && processedRates.length > 0) {
//         if (!dataByAreaAndType[sfAreaId]) {
//           dataByAreaAndType[sfAreaId] = [];
//         }

//         processedRates.forEach(rateInfo => {
//           dataByAreaAndType[sfAreaId].push({
//             ItemCode: String(row.ItemCode || ''),
//             Rate: rateInfo.rate,
//             RateType: rateInfo.rateType,
//             DML: "I"
//           });
//         });
//       }

//       return {
//         AreaCode: String(row.AreaCode || ''),
//         AreaId: sfAreaId,
//         ItemCode: String(row.ItemCode || ''),
//         ...processedRates.reduce((acc, pr) => {
//           acc[pr.rateColumn] = pr.rate;
//           return acc;
//         }, {}),
//         DML: "I"
//       };
//     });

//     // Set the validated rows and errors
//     setInvalidRowsList(invalidRowsList);
//     setInvalidRows(invalidRowsList.map(item => item.rowNumber));
//     setRateErrorRows([]);
//     setDuplicateRows(duplicateRowsList);

//     // Calculate all error rows
//     const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...duplicateRowsList])];

//     if (allErrorsRows.length > 0) {
//       let errorMessage = '';

//       if (invalidRowsList.length > 0) {
//         // Group rows by error type for more specific feedback
//         const errorsByType = {
//           missing_areacode: [],
//           invalid_areacode: [],
//           missing_identifier: [],
//           missing_rate: [],
//           negative_value: [],
//           invalid_decimals: [],
//           special_chars: [],
//           double_decimal: [],
//           non_numeric_value: [],
//           item_not_mapped: [],
//         };

//         invalidRowsList.forEach(item => {
//           item.errors.forEach(errorType => {
//             errorsByType[errorType].push(item.rowNumber);
//           });
//         });

//         errorMessage += 'Data validation errors found: ';

//         if (errorsByType.missing_areacode.length > 0) {
//           errorMessage += `Missing AreaCode values in rows: ${errorsByType.missing_areacode.join(', ')}. `;
//         }
//         if (errorsByType.invalid_areacode.length > 0) {
//           errorMessage += `Invalid AreaCode values in rows: ${errorsByType.invalid_areacode.join(', ')} (AreaCode not found in system). `;
//         }
//         if (errorsByType.missing_identifier.length > 0) {
//           errorMessage += `Missing ItemCode values in rows: ${errorsByType.missing_identifier.join(', ')}. `;
//         }
//         if (errorsByType.negative_value.length > 0) {
//           errorMessage += `Negative values in rows: ${errorsByType.negative_value.join(', ')}. `;
//         }
//         if (errorsByType.invalid_decimals.length > 0) {
//           errorMessage += `More than 2 decimal places in Rate in rows: ${errorsByType.invalid_decimals.join(', ')}. `;
//         }
//         if (errorsByType.special_chars.length > 0) {
//           errorMessage += `Special characters in ItemCode in rows: ${errorsByType.special_chars.join(', ')}. `;
//         }
//         if (errorsByType.double_decimal.length > 0) {
//           errorMessage += `Double decimal points in rows: ${errorsByType.double_decimal.join(', ')}. `;
//         }
//         if (errorsByType.non_numeric_value.length > 0) {
//           errorMessage += `Non-numeric values in rows: ${errorsByType.non_numeric_value.join(', ')}. `;
//         }
//         if (errorsByType.item_not_mapped.length > 0) {
//           errorMessage += `ItemCode not mapped in master data in rows: ${errorsByType.item_not_mapped.join(', ')}. `;
//         }
//       }

//       if (duplicateRowsList.length > 0) {
//         errorMessage += `Duplicate ItemCode+RateType combinations in rows: ${duplicateRowsList.join(', ')}. `;
//       }

//       setNotification({
//         open: true,
//         message: errorMessage,
//         severity: 'error'
//       });

//       // Log validation errors to console
//       console.log('\n' + '='.repeat(80));
//       console.log('❌ VALIDATION ERRORS FOUND:');
//       console.log('='.repeat(80));
//       if (invalidRowsList.length > 0) {
//         console.log('%cInvalid Rows:', 'color: #f44336; font-weight: bold;');
//         console.log(JSON.stringify(invalidRowsList, null, 2));
//       }
//       if (duplicateRowsList.length > 0) {
//         console.log('%cDuplicate Rows:', 'color: #f44336; font-weight: bold;');
//         console.log('Rows with duplicate Area+ItemCode+RateType combinations:', duplicateRowsList);
//       }
//       console.log('='.repeat(80) + '\n');

//       // Still set data for display but don't validate for upload
//       setExcelData(jsonData);
//       if (allErrorsRows.length === jsonData.length) {
//         setValidatedData(null); // No valid data to upload
//       } else {
//         // Filter out invalid entries for upload
//         const validatedEntries = validData.filter((_, index) =>
//           !allErrorsRows.includes(index + 1)
//         );
//         setValidatedData(validatedEntries);

//         // Log partial data structure (only valid rows)
//         console.log('='.repeat(80));
//         console.log('PARTIAL DATA STRUCTURE (Valid rows only):');
//         console.log('='.repeat(80));
//         console.log(JSON.stringify(dataByAreaAndType, null, 2));
//         console.log('='.repeat(80));
//       }
//     } else {
//       setExcelData(jsonData);
//       setValidatedData(validData);
//       setGroupedDataByArea(dataByAreaAndType);

//       const areaCount = Object.keys(dataByAreaAndType).length;
//       const totalRecords = jsonData.length;

//       // Log the organized data structure in JSON format
//       console.log('\n' + '='.repeat(80));
//       console.log('✓ VALIDATION SUCCESSFUL - DATA STRUCTURE:');
//       console.log('='.repeat(80));
//       console.log('%cFull JSON Structure:', 'color: #4CAF50; font-weight: bold;');
//       console.log(JSON.stringify(dataByAreaAndType, null, 2));
//       console.log('='.repeat(80));
//       console.log('%cSUMMARY:', 'color: #2196F3; font-weight: bold;');
//       console.log(`Total Records: ${totalRecords}`);
//       console.log(`Total Areas: ${areaCount}`);

//       // Log detailed breakdown
//       console.log('\n%cDETAILED BREAKDOWN:', 'color: #FF9800; font-weight: bold;');
//       Object.entries(dataByAreaAndType).forEach(([areaId, items]) => {
//         console.log(`\n%cArea ID: ${areaId}`, 'color: #2196F3; font-weight: bold; font-size: 14px;');

//         // Group items by rate type for display
//         const groupedByType = {};
//         items.forEach(item => {
//           if (!groupedByType[item.RateType]) {
//             groupedByType[item.RateType] = [];
//           }
//           groupedByType[item.RateType].push(item);
//         });

//         Object.entries(groupedByType).forEach(([rateType, typeItems]) => {
//           const typeNames = { '1R': 'Regular Rate', '2B': 'Bulk Rate', '3V': 'Volume Rate' };
//           const typeEmoji = { '1R': '📍', '2B': '📦', '3V': '📊' };
//           console.log(`\n  ${typeEmoji[rateType]} ${typeNames[rateType]} (${rateType}): ${typeItems.length} items`);
//           typeItems.forEach(item => {
//             console.log(`     └─ ItemCode: ${item.ItemCode}, Rate: ${item.Rate}`);
//           });
//         });
//       });
//       console.log('\n' + '='.repeat(80) + '\n');

//       setNotification({
//         open: true,
//         message: `Successfully imported ${totalRecords} items from ${areaCount} area(s). Ready to upload.`,
//         severity: 'success'
//       });
//     }

//     setIsLoading(false);
//   };

//   const handleUpload = async () => {
//     // Check for validation errors before proceeding
//     if (!validatedData || validatedData.length === 0) {
//       setNotification({
//         open: true,
//         message: 'Please import and validate data before uploading',
//         severity: 'warning'
//       });
//       return;
//     }

//     // Check if there are any validation errors
//     if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
//       setNotification({
//         open: true,
//         message: 'Please fix all validation errors before uploading',
//         severity: 'error'
//       });
//       return;
//     }

//     // Check if we have grouped data by area
//     if (!groupedDataByArea || Object.keys(groupedDataByArea).length === 0) {
//       setNotification({
//         open: true,
//         message: 'No valid data grouped by area found',
//         severity: 'warning'
//       });
//       return;
//     }

//     setIsUploading(true);

//     try {
//       // Convert to IST (UTC+5:30)
//       const now = new Date();
//       const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
//       const istDate = new Date(now.getTime() + istOffset);
//       const currentDate = istDate.toISOString();
//       const userId = localStorage.getItem('userId') || 'UnknownUser';

//       const areaIds = Object.keys(groupedDataByArea);
//       let successfulUploads = 0;
//       let totalErrors = [];
//       let totalSuccessMessages = [];

//       // Upload data for each area (single API call per area with all rate types)
//       for (const areaId of areaIds) {
//         const areaData = groupedDataByArea[areaId]; // Array of items with RateType included

//         // Build rateDetail with all items (all rate types) for this area
//         const rateDetail = areaData.map(row => {
//           // Get QualifyQty from bulk rates API
//           let qualifyQtyValue = 0;
//           if (bulkRates && bulkRates.RateSchemeUpdate) {
//             for (const parentItem of bulkRates.RateSchemeUpdate) {
//               if (parentItem.childlist) {
//                 for (const childItem of parentItem.childlist) {
//                   if (String(childItem.ChildItemId) === String(row.ItemCode)) {
//                     if (childItem.rates) {
//                       for (const rate of childItem.rates) {
//                         if (rate.AreaId === areaId && rate.BulkRateType === row.RateType) {
//                           qualifyQtyValue = rate.QualifyQty || 0;
//                           break;
//                         }
//                       }
//                     }
//                     break;
//                   }
//                 }
//               }
//             }
//           }
//           return {
//             itemCode: row.ItemCode,
//             qualifyQty: qualifyQtyValue,
//             rate: parseFloat(row.Rate) || 0,
//             dml: row.DML || "I"
//           };
//         });

//         // Create single payload for the entire area
//         const payload = {
//           uniqueId: "",
//           rebateSchemeType: 'AREA',
//           areaId: areaId,
//           rebateSchemeId: '',
//           customerId: '',
//           dateOfEntry: currentDate,
//           createdUserCode: userId,
//           rateDetail: rateDetail
//         };

//         console.log(`Uploading data for AreaID: ${areaId}`, payload);

//         try {
//           const response = await fetch(`${local_url}/api/CustomerRate`, {
//             method: 'POST',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(payload)
//           });

//           if (!response.ok) {
//             throw new Error(`API response error for area ${areaId}: ${response.status} ${response.statusText}`);
//           }

//           const result = await response.json();

//           // Handle success
//           if (result.result === 1 || (result.dbResult && Array.isArray(result.dbResult) && result.dbResult.length > 0)) {
//             successfulUploads++;
//             const description = result.description || result.dbResult?.[0]?.UniqueId || 'Upload successful';
//             totalSuccessMessages.push(`Area ${areaId}: ${description}`);

//             // Call encryption and webhook APIs if description is available
//             if (result.description) {
//               console.log(`Starting encryption and webhook chain for area ${areaId}...`);

//               try {
//                 // Step 1: Call encryption API
//                 const encryptionResponse = await fetch(`${local_url}/api/webhook-keys/encrypt`, {
//                   method: 'POST',
//                   headers: {
//                     'Content-Type': 'application/json'
//                   },
//                   body: JSON.stringify({
//                     keyId: "12334311",
//                     webhookKey: result.description
//                   })
//                 });

//                 if (encryptionResponse.ok) {
//                   const encryptionResult = await encryptionResponse.json();
//                   console.log(`Encryption API response for area ${areaId}:`, encryptionResult);

//                   // Step 2: Call webhook API with encrypted key
//                   if (encryptionResult && encryptionResult.encryptedKey) {
//                     try {
//                       // FIXED: Directly use encryptedKey WITHOUT removing padding
//                       const webhookPayload = {
//                         uId: "0000000001",
//                         id: encryptionResult.encryptedKey,
//                         currStatus: "insert",
//                         updatedOn: new Date().toISOString(),
//                         message: result.description
//                       };

//                       console.log(`Webhook API payload for area ${areaId}:`, webhookPayload);

//                       const webhookResponse = await fetch(`${web_hook}/WebHook/InsertHorecaRate`, {
//                         method: 'POST',
//                         headers: {
//                           'Content-Type': 'application/json'
//                         },
//                         body: JSON.stringify(webhookPayload)
//                       });

//                       if (webhookResponse.ok) {
//                         const webhookResult = await webhookResponse.json();
//                         console.log(`Webhook API success for area ${areaId}:`, webhookResult);
//                       } else {
//                         console.warn(`Webhook API failed for area ${areaId}, but continuing with upload success`);
//                       }
//                     } catch (webhookError) {
//                       console.warn(`Webhook API error for area ${areaId}:`, webhookError);
//                     }
//                   } else {
//                     console.warn(`No encrypted key received for area ${areaId}`);
//                   }
//                 } else {
//                   console.warn(`Encryption API failed for area ${areaId}, but continuing with upload success`);
//                 }
//               } catch (encryptionError) {
//                 console.warn(`Encryption API error for area ${areaId}:`, encryptionError);
//               }
//             }
//           }

//           // Handle API errors
//           if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
//             const areaErrors = result.errdescr.map(err => ({
//               ...err,
//               areaId: areaId
//             }));
//             totalErrors.push(...areaErrors);
//           }

//         } catch (areaError) {
//           console.error(`Error uploading data for area ${areaId}:`, areaError);
//           totalErrors.push({
//             areaId: areaId,
//             itemCode: 'API_ERROR',
//             ErrorDescr: areaError.message
//           });
//         }
//       }

//       // Set combined API errors for display
//       if (totalErrors.length > 0) {
//         setApiErrors(totalErrors);
//         setShowApiErrorsDialog(true);
//       }

//       // Show final results
//       if (successfulUploads > 0) {
//         let message = `Successfully uploaded data for ${successfulUploads} out of ${areaIds.length} area(s).`;
//         if (totalErrors.length > 0) {
//           message += ` ${totalErrors.length} item(s) had errors.`;
//         }

//         setNotification({
//           open: true,
//           message: message,
//           severity: totalErrors.length > 0 ? 'warning' : 'success'
//         });

//         // Clear file only if all areas uploaded successfully
//         if (successfulUploads === areaIds.length && totalErrors.length === 0) {
//           clearFile();
//         }
//       } else {
//         setNotification({
//           open: true,
//           message: `Failed to upload data for all ${areaIds.length} area(s).`,
//           severity: 'error'
//         });
//       }

//     } catch (error) {
//       console.error('Error in upload process:', error);
//       setNotification({
//         open: true,
//         message: `Error in upload process: ${error.message}`,
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const ApiErrorsDialog = () => {
//     return (
//       <Dialog
//         open={showApiErrorsDialog}
//         onClose={() => setShowApiErrorsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box display="flex" alignItems="center">
//             <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
//             API Validation Errors
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Area ID</TableCell>
//                   <TableCell>Rate Type</TableCell>
//                   <TableCell>Item Code</TableCell>
//                   <TableCell>Error Description</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {apiErrors.map((error, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{error.areaId || '-'}</TableCell>
//                     <TableCell>{error.rateType || '-'}</TableCell>
//                     <TableCell>{error.itemCode}</TableCell>
//                     <TableCell>{error.ErrorDescr}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setShowApiErrorsDialog(false)}
//             color="primary"
//             variant="contained"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   const handleDownloadSample = () => {
//     // Filter out PLANT and RETAIL from available areas
//     const excludedAreaCodes = ['PLANT', 'RETAIL'];
//     const validAreas = areas.filter(area => !excludedAreaCodes.includes(area.AreaCode));

//     if (validAreas.length === 0) {
//       setNotification({
//         open: true,
//         message: 'No valid areas available for sample data',
//         severity: 'warning'
//       });
//       return;
//     }

//     // Generate sample data for each valid area
//     const sampleData = [];
//     const sampleItems = [
//       { code: '71001211', rate: 51, qty: 20 },
//       { code: '71001213', rate: 120, qty: 41 },
//       { code: '71001212', rate: 130, qty: 140 }
//     ];

//     validAreas.forEach((area, areaIndex) => {
//       // Add 2-3 sample items for each area
//       const itemsForArea = sampleItems.slice(0, Math.min(2 + (areaIndex % 2), sampleItems.length));
//       itemsForArea.forEach(item => {
//         sampleData.push({
//           AreaCode: area.AreaCode,
//           ItemCode: item.code,
//           Rate: item.rate,
//           QualifyQty: item.qty
//         });
//       });
//     });

//     const worksheet = XLSX.utils.json_to_sheet(sampleData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Sample Data');

//     XLSX.writeFile(workbook, 'HorecaUpload_Sample.xlsx');

//     setNotification({
//       open: true,
//       message: 'Sample Excel file downloaded successfully',
//       severity: 'success'
//     });
//   };

//   const clearFile = () => {
//     setFile(null);
//     setFileName('');
//     setExcelData([]);
//     setValidatedData(null);
//     setInvalidRows([]);
//     setDuplicateRows([]);
//     setRateErrorRows([]);
//     setGroupedDataByArea({});

//     // Reset the file input value if the ref is available
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const handleCloseNotification = () => {
//     setNotification({ ...notification, open: false });
//   };

//   return (
//     <>
//       <Header />
//       <ThemeProvider theme={theme}>
//         <Box sx={{
//           minHeight: '100vh',
//           backgroundColor: 'background.default',
//           py: 1,
//           overflow: 'auto',
//           maxHeight: '100vh'
//         }}>
//           <Container maxWidth="lg" sx={{ py: 1, height: '100%', overflow: 'auto' }}>
//             <Grow in={true} timeout={800}>
//               <Paper elevation={3} sx={{ p: 2, borderRadius: 2, overflow: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
//                 <Box sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: 1,
//                   borderBottom: '1px solid #e0e0e0',
//                   pb: 0.8
//                 }}>
//                   <TableChartIcon sx={{ fontSize: 24, mr: 1, color: 'primary.main' }} />
//                   <Typography variant="h6" component="h1" sx={{ fontSize: '1.2rem' }}>
//                     HoReCa Rate Upload
//                   </Typography>
//                   <Tooltip title="Upload Excel files with AreaCode, ItemCode, RegularRate, BulkRate, VolumeRate columns">
//                     <IconButton sx={{ ml: 1 }} size="small">
//                       <InfoIcon color="action" />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>

//                 {/* Information Box */}
//                 {/* <Box sx={{
//                   backgroundColor: '#e3f2fd',
//                   p: 2,
//                   borderRadius: 2,
//                   mb: 2,
//                   border: '1px solid #bbdefb'
//                 }}>
//                   <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
//                     Upload Information
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                     Areas will be automatically detected from the AreaID column in your Excel file.
//                     The system will upload data separately for each area found in the file.
//                   </Typography>

//                   {isLoadingAreas ? (
//                     <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
//                       <CircularProgress size={16} sx={{ mr: 1 }} />
//                       <Typography variant="caption">Loading area information in background...</Typography>
//                     </Box>
//                   ) : areas.length > 0 ? (
//                     <Box sx={{ mt: 1.5 }}>
//                       <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.primary' }}>
//                         Valid AreaIDs:
//                       </Typography>
//                       <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                         {areas.map((area, index) => (
//                           <Typography
//                             key={area.AreaId}
//                             variant="caption"
//                             sx={{
//                               backgroundColor: '#e3f2fd',
//                               color: '#1976d2',
//                               px: 1,
//                               py: 0.5,
//                               borderRadius: 1,
//                               fontSize: '0.75rem',
//                               fontFamily: 'monospace'
//                             }}
//                           >
//                             {area.AreaId} ({area.AreaName})
//                           </Typography>
//                         ))}
//                       </Box>
//                     </Box>
//                   ) : null}
//                 </Box> */}

//                 <Box sx={{
//                   backgroundColor: '#f8faff',
//                   p: 1.5,
//                   borderRadius: 2,
//                   mb: 1,
//                   border: '1px solid #e3f2fd'
//                 }}>
//                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500, fontSize: '0.95rem' }}>
//                     Upload Excel Data
//                   </Typography>

//                   <Grid container spacing={1.5} alignItems="center">
//                     <Grid item xs={12} md={4}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Button
//                           variant="contained"
//                           component="label"
//                           startIcon={<FileOpenIcon />}
//                           sx={{
//                             mr: 1.5,
//                             py: 1,
//                             px: 2,
//                             background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
//                             boxShadow: '0 2px 4px 1px rgba(33, 203, 243, .3)',
//                             color: 'white',
//                             '&:hover': {
//                               background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
//                             }
//                           }}
//                         >
//                           Choose File
//                           <input
//                             ref={fileInputRef}
//                             type="file"
//                             accept=".xlsx, .xls"
//                             hidden
//                             onChange={handleFileChange}
//                           />
//                         </Button>

//                         <Button
//                           variant="outlined"
//                           startIcon={<DownloadIcon />}
//                           onClick={handleDownloadSample}
//                           sx={{
//                             py: 1,
//                             px: 2,
//                             borderColor: '#4caf50',
//                             color: '#4caf50',
//                             '&:hover': {
//                               borderColor: '#388e3c',
//                               color: '#388e3c',
//                               backgroundColor: 'rgba(76, 175, 80, 0.04)',
//                             }
//                           }}
//                         >
//                           Download Sample
//                         </Button>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12} md={8}>
//                       {fileName && (
//                         <Fade in={!!fileName}>
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <Chip
//                               label={fileName}
//                               variant="outlined"
//                               color="primary"
//                               onDelete={clearFile}
//                               deleteIcon={<DeleteIcon />}
//                               sx={{ maxWidth: '250px' }}
//                             />
//                           </Box>
//                         </Fade>
//                       )}
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={handleImport}
//                         disabled={!file || isLoading}
//                         fullWidth
//                         sx={{
//                           py: 1,
//                           background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
//                           boxShadow: file && !isLoading ? '0 2px 4px 1px rgba(76, 175, 80, .3)' : '',
//                           '&:hover': {
//                             background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isLoading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Processing...
//                           </Box>
//                         ) : (
//                           <>
//                             <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
//                           </>
//                         )}
//                       </Button>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={handleUpload}
//                         disabled={
//                           !validatedData ||
//                           isUploading ||
//                           invalidRows.length > 0 ||
//                           duplicateRows.length > 0 ||
//                           rateErrorRows.length > 0 ||
//                           !groupedDataByArea ||
//                           Object.keys(groupedDataByArea).length === 0
//                         }
//                         fullWidth
//                         sx={{
//                           py: 1,
//                           background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
//                             'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
//                           boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
//                             '0 2px 4px 1px rgba(255, 87, 34, .3)' : '',
//                           '&:hover': {
//                             background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
//                               'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
//                           }
//                         }}
//                       >
//                         {isUploading ? (
//                           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                             Uploading...
//                           </Box>
//                         ) : (
//                           <>
//                             <SendIcon sx={{ mr: 1 }} /> Submit
//                           </>
//                         )}
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {(invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) && (
//                   <Alert
//                     severity="warning"
//                     sx={{ mb: 1 }}
//                     action={
//                       <Tooltip title="Rows with errors are highlighted in red">
//                         <IconButton size="small">
//                           <InfoIcon />
//                         </IconButton>
//                       </Tooltip>
//                     }
//                   >
//                     <Typography variant="subtitle2">Validation Errors Found:</Typography>
//                     <Box component="ul" sx={{ mt: 1, pl: 2 }}>
//                       {invalidRowsList && invalidRowsList.length > 0 ? (
//                         <li>
//                           Data validation errors:
//                           <Box component="ul" sx={{ pl: 2 }}>
//                             {invalidRowsList.map((item, idx) => (
//                               <li key={idx}>
//                                 Row {item.rowNumber}: {item.errors && Array.isArray(item.errors) ? item.errors.map(err => {
//                                   switch (err) {
//                                     case 'missing_areacode': return 'Missing AreaCode';
//                                     case 'invalid_areacode': return 'Invalid AreaCode (not found in system)';
//                                     case 'missing_identifier': return 'Missing ItemCode';
//                                     case 'missing_rate': return 'Missing Rate or QualifyQty value';
//                                     case 'negative_value': return 'Negative value';
//                                     case 'invalid_decimals': return 'More than 2 decimal places in Rate';
//                                     case 'special_chars': return 'Special characters in ItemCode';
//                                     case 'double_decimal': return 'Double decimal point';
//                                     case 'non_numeric_value': return 'Non-numeric value';
//                                     case 'item_not_mapped': return 'ItemCode not found in system (not mapped in master data)';
//                                     default: return err;
//                                   }
//                                 }).join(', ') : 'Unknown error'}
//                               </li>
//                             ))}
//                           </Box>
//                         </li>
//                       ) : (
//                         invalidRows.length > 0 && <li>Invalid data format in rows: {invalidRows.join(', ')}</li>
//                       )}
//                       {duplicateRows.length > 0 && (
//                         <li>
//                           Duplicate ItemCode combinations in rows: {duplicateRows.join(', ')}
//                         </li>
//                       )}
//                     </Box>
//                   </Alert>
//                 )}

//                 <Divider sx={{ my: 2 }} />

//                 <Box sx={{ mt: 1 }}>
//                   <Typography variant="h6" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', fontSize: '0.95rem' }}>
//                     <TableChartIcon sx={{ mr: 1, fontSize: 18 }} /> Data Preview
//                   </Typography>

//                   {excelData.length > 0 ? (
//                     <Fade in={excelData.length > 0} timeout={800}>
//                       <TableContainer component={Paper} sx={{
//                         mt: 1,
//                         boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
//                         borderRadius: 1.5,
//                         maxHeight: 300,
//                         overflow: 'auto'
//                       }}>
//                         <Table aria-label="excel data table" stickyHeader size="small">
//                           <TableHead>
//                             <TableRow sx={{ backgroundColor: '#f0f5ff' }}>
//                               <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px', minWidth: '80px' }}>Area</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px', minWidth: '120px' }}>Item Name</TableCell>
//                               <TableCell sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px', minWidth: '90px' }}>Item Code</TableCell>
//                               <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Regular Rate</TableCell>
//                               <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Reg Qty</TableCell>
//                               <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Bulk Rate</TableCell>
//                               <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Bulk Qty</TableCell>
//                               <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Volume Rate</TableCell>
//                               <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '0.8rem', padding: '6px' }}>Vol Qty</TableCell>
//                             </TableRow>
//                           </TableHead>

//                           <TableBody>
//                             {excelData.map((row, index) => {
//                               const rowNum = index + 1;
//                               const hasError = invalidRows.includes(rowNum) ||
//                                 duplicateRows.includes(rowNum);

//                               return (
//                                 <TableRow
//                                   key={index}
//                                   sx={{
//                                     backgroundColor: hasError ? '#ffebee' : (index % 2 === 0 ? '#fff' : '#fafafa'),
//                                     '& td': { fontSize: '0.8rem', padding: '6px' },
//                                     '&:hover': { backgroundColor: hasError ? '#ffcdd2' : '#f5f5f5' }
//                                   }}
//                                 >
//                                   <TableCell>{row.AreaCode || '-'}</TableCell>
//                                   <TableCell>{getItemName(row.ItemCode)}</TableCell>
//                                   <TableCell>{row.ItemCode}</TableCell>
//                                   <TableCell align="right">
//                                     {row.RegularRate ? parseFloat(row.RegularRate).toFixed(2) : '-'}
//                                   </TableCell>
//                                   <TableCell align="center">
//                                     {row.RegularRate ? getQualifyQty(row.ItemCode, row.AreaCode, '1R') : '-'}
//                                   </TableCell>
//                                   <TableCell align="right">
//                                     {row.BulkRate ? parseFloat(row.BulkRate).toFixed(2) : '-'}
//                                   </TableCell>
//                                   <TableCell align="center">
//                                     {row.BulkRate ? getQualifyQty(row.ItemCode, row.AreaCode, '2B') : '-'}
//                                   </TableCell>
//                                   <TableCell align="right">
//                                     {row.VolumeRate ? parseFloat(row.VolumeRate).toFixed(2) : '-'}
//                                   </TableCell>
//                                   <TableCell align="center">
//                                     {row.VolumeRate ? getQualifyQty(row.ItemCode, row.AreaCode, '3V') : '-'}
//                                   </TableCell>
//                                 </TableRow>
//                               );
//                             })}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Fade>
//                   ) : (
//                     <Fade in={!excelData.length} timeout={800}>
//                       <Box
//                         sx={{
//                           p: 2,
//                           textAlign: 'center',
//                           bgcolor: '#fafafa',
//                           borderRadius: 2,
//                           border: '2px dashed #e0e0e0',
//                           display: 'flex',
//                           flexDirection: 'column',
//                           alignItems: 'center',
//                           justifyContent: 'center'
//                         }}
//                       >
//                         <CloudUploadIcon sx={{ fontSize: 36, color: '#bdbdbd', mb: 1 }} />
//                         <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
//                           No Data Available
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           Upload an Excel file to view your data
//                         </Typography>
//                       </Box>
//                     </Fade>
//                   )}
//                 </Box>

//                 {validatedData && validatedData.length > 0 && (
//                   <Box sx={{ mt: 2, p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1.5, border: '1px solid #c8e6c9' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <InfoIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       Data validated successfully. {validatedData.length} valid records ready to upload.
//                       {invalidRows.length > 0 || duplicateRows.length > 0 ?
//                         ` (${invalidRows.length + duplicateRows.length} invalid records will be skipped)` :
//                         ''}
//                     </Typography>
//                   </Box>
//                 )}

//                 {apiErrors.length > 0 && (
//                   <Box sx={{ mt: 2, p: 1.5, bgcolor: '#fff3e0', borderRadius: 1.5, border: '1px solid #ffe0b2' }}>
//                     <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
//                       <ErrorOutlineIcon sx={{ mr: 0.5, fontSize: 18 }} />
//                       {apiErrors.length} items failed validation during upload.
//                       <Button
//                         color="warning"
//                         variant="outlined"
//                         size="small"
//                         onClick={() => setShowApiErrorsDialog(true)}
//                         sx={{ ml: 1.5, fontSize: '0.75rem', py: 0.5 }}
//                       >
//                         View Errors
//                       </Button>
//                     </Typography>
//                   </Box>
//                 )}
//               </Paper>
//             </Grow>

//             <Snackbar
//               open={notification.open}
//               autoHideDuration={6000}
//               onClose={handleCloseNotification}
//               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//               <Alert
//                 onClose={handleCloseNotification}
//                 severity={notification.severity}
//                 variant="filled"
//                 sx={{ width: '100%' }}
//               >
//                 {notification.message}
//               </Alert>
//             </Snackbar>
//           </Container>
//         </Box>

//         {/* ColumnMismatchDialog component */}
//         <Dialog
//           open={showConfirmDialog}
//           onClose={() => setShowConfirmDialog(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle>
//             <Box display="flex" alignItems="center">
//               <InfoIcon color="primary" sx={{ mr: 1 }} />
//               Confirm Upload
//             </Box>
//           </DialogTitle>
//           <DialogContent>
//             <Typography variant="body1">
//               You are about to upload {validatedData ? validatedData.length : 0} HORECA rate records.
//               {invalidRows.length > 0 || duplicateRows.length > 0 ?
//                 ` ${invalidRows.length + duplicateRows.length} invalid records will be skipped.` : ''}
//             </Typography>
//             <Typography variant="body1" sx={{ mt: 2 }}>
//               Do you want to proceed?
//             </Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setShowConfirmDialog(false)} color="primary">
//               Cancel
//             </Button>
//             <Button
//               onClick={() => {
//                 setShowConfirmDialog(false);
//                 handleUpload();
//               }}
//               color="primary"
//               variant="contained"
//               startIcon={<SendIcon />}
//             >
//               Proceed
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <ApiErrorsDialog />
//       </ThemeProvider>
//     </>
//   );
// };

// export default HorecaUpload;


























































import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Grid,
  CircularProgress,
  Chip,
  Divider,
  Fade,
  Grow,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField
} from '@mui/material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import InfoIcon from '@mui/icons-material/Info';
import TableChartIcon from '@mui/icons-material/TableChart';
import SendIcon from '@mui/icons-material/Send';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import * as XLSX from 'xlsx';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from '../Header';
import { local_signage, local_url } from '../Const';
import { getServerTodayStr, getCachedServerTodayStr } from '../utils/serverDate';

// Valid From is fixed and no longer user-editable for this upload flow (single/bulk area).
const FIXED_VALID_FROM_DATE = '20260827';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f7fa',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 500,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '10px 24px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f0f5ff',
          fontWeight: 'bold',
        },
      },
    },
  },
});

// Central place to manage the required columns for the Excel template
const REQUIRED_COLUMNS = ['AreaCode', 'ItemCode', 'Rate', 'QualifyQty', 'ValidityUpto'];

// Color/icon presets for the floating toast, keyed by notification severity.
// Matches the "customer upload" toast: white card with a colored glow border,
// colored icon, dark message text, and a plain neutral close X.
const TOAST_STYLES = {
  error: { iconColor: '#f59e0b', textColor: '#92400e', borderColor: '#f59e0b', Icon: HighlightOffOutlinedIcon },
  warning: { iconColor: '#f59e0b', textColor: '#92400e', borderColor: '#f59e0b', Icon: HighlightOffOutlinedIcon },
  success: { iconColor: '#16a34a', textColor: '#166534', borderColor: '#16a34a', Icon: CheckCircleOutlineIcon },
  info: { iconColor: '#2563eb', textColor: '#1e3a8a', borderColor: '#2563eb', Icon: InfoIcon },
};

// Self-contained floating toast. Deliberately NOT using MUI's <Snackbar> -
// Snackbar renders through a portal with its own Transition/clone-element
// wiring, and when this component is embedded inside another app's custom
// modal (its own high z-index / stacking context), the Snackbar can end up
// invisible or stuck behind the modal. This version is a plain fixed-position
// Box with its own show/hide state and auto-hide timer, and a very high
// z-index, so it always renders on top regardless of the parent markup.
const FloatingToast = ({ open, message, severity, onClose, autoHideDuration = 6000 }) => {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => {
      onClose();
    }, autoHideDuration);
    return () => clearTimeout(timer);
  }, [open, message, autoHideDuration, onClose]);

  if (!open) return null;

  const style = TOAST_STYLES[severity] || TOAST_STYLES.info;
  const Icon = style.Icon;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 999999,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        backgroundColor: '#fff',
        border: `2px solid ${style.borderColor}`,
        borderRadius: 3,
        boxShadow: `0 8px 24px rgba(0,0,0,0.18), 0 0 0 3px ${style.borderColor}22`,
        px: 2,
        py: 1.25,
        maxWidth: 480,
      }}
    >
      <Icon sx={{ color: style.iconColor, fontSize: 22, flexShrink: 0 }} />
      <Typography sx={{ color: style.textColor, fontWeight: 500, fontSize: '0.9rem', flexGrow: 1 }}>
        {message}
      </Typography>
      <IconButton size="small" onClick={onClose} sx={{ p: 0.5 }}>
        <CloseIcon fontSize="small" sx={{ color: '#374151' }} />
      </IconButton>
    </Box>
  );
};

export const HorecaUpload = ({ embedded = false, onClose } = {}) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const [validatedData, setValidatedData] = useState(null);
  const [invalidRows, setInvalidRows] = useState([]);
  const [duplicateRows, setDuplicateRows] = useState([]);
  const [rateErrorRows, setRateErrorRows] = useState([]);
  const token = localStorage.getItem('AuthorizationToken');
  const fileInputRef = useRef(null);
  const [invalidRowsList, setInvalidRowsList] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [showApiErrorsDialog, setShowApiErrorsDialog] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [excelColumns, setExcelColumns] = useState([]);

  // Track missing required columns (used to block validation, not rendered as a banner)
  const [missingColumns, setMissingColumns] = useState([]);

  // New state for SF Areas
  const [areas, setAreas] = useState([]);
  const [areaCodeToIdMap, setAreaCodeToIdMap] = useState({});
  const [selectedArea, setSelectedArea] = useState('');
  const [isLoadingAreas, setIsLoadingAreas] = useState(false);
  const [areaError, setAreaError] = useState('');

  // New state for grouped data by area
  const [groupedDataByArea, setGroupedDataByArea] = useState({});

  // Fetch SF Areas on component mount
  useEffect(() => {
    if (token) {
      fetchAreas();
    } else {
      setNotification({
        open: true,
        message: 'No authorization token found. Please login first.',
        severity: 'error'
      });
    }
  }, [token]);

  const fetchAreas = async () => {
    setIsLoadingAreas(true);
    setAreaError('');

    try {
      const userId = localStorage.getItem('userId') || 'UnknownUser';

      const response = await fetch(`${local_url}/api/SFArea/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch areas: ${response.status}`);
      }

      const data = await response.json();
      setAreas(data.map(area => ({
        AreaId: area.sfAreaId,
        AreaName: area.sfAreaName,
        AreaCode: area.areaCode
      })));

      // Create a mapping from area code to sfAreaId for lookup
      const codeToIdMapping = {};
      data.forEach(area => {
        codeToIdMapping[area.areaCode] = area.sfAreaId;
      });
      setAreaCodeToIdMap(codeToIdMapping);

      console.log(`Successfully loaded ${data.length} areas in background`, codeToIdMapping);
    } catch (error) {
      console.error('Error fetching areas:', error);
      setAreaError('Failed to load areas. Please refresh the page or contact support.');
    } finally {
      setIsLoadingAreas(false);
    }
  };

  const handleAreaChange = (event) => {
    setSelectedArea(event.target.value);
  };

  const formatValidTill = (dateValue) => {
    if (!dateValue) return "";
    if (typeof dateValue === 'number') {
      // If the number is 8 digits it's already YYYYMMDD (e.g. 20261231 typed in Excel)
      const numStr = String(Math.floor(dateValue));
      if (/^\d{8}$/.test(numStr)) return numStr;
      // Otherwise treat as an Excel serial date (e.g. 46238 = 2026-07-31)
      const date = XLSX.SSF.parse_date_code(dateValue);
      if (!date) return "";
      return `${date.y}${String(date.m).padStart(2, '0')}${String(date.d).padStart(2, '0')}`;
    }
    const str = String(dateValue).trim();
    // Already in YYYYMMDD format
    if (/^\d{8}$/.test(str)) return str;
    // Handle YYYY-MM-DD or other parseable date strings
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
    }
    return "";
  };

  // Short, prefix-less error descriptions - no "Data validation errors
  // found:" prefix and no row numbers, matching the customer upload toast
  // (e.g. "ValidityUpto cannot be less than today's date.").
  const ERROR_TYPE_MESSAGES = {
    missing_areacode: 'Missing AreaCode value.',
    invalid_areacode: 'Invalid AreaCode (not found in system).',
    missing_identifier: 'Missing ItemCode value.',
    missing_rate: 'Missing Rate or QualifyQty value.',
    missing_validity: 'Missing ValidityUpto value.',
    past_validity: "ValidityUpto cannot be less than today's date.",
    negative_value: 'Negative value found.',
    invalid_decimals: 'More than 2 decimal places in Rate.',
    special_chars: 'Special characters in ItemCode.',
    double_decimal: 'Double decimal point in Rate.',
    non_numeric_value: 'Non-numeric value found.',
  };

  // Shared builder for the validation error message, used for the toast text.
  // Returns only the unique error descriptions present, joined with a space -
  // no "Data validation errors found:" prefix, no row numbers.
  const buildValidationErrorMessage = (rowsList, dupRowsList) => {
    const seen = new Set();
    const messages = [];

    rowsList.forEach(item => {
      item.errors.forEach(errorType => {
        if (!seen.has(errorType) && ERROR_TYPE_MESSAGES[errorType]) {
          seen.add(errorType);
          messages.push(ERROR_TYPE_MESSAGES[errorType]);
        }
      });
    });

    if (dupRowsList.length > 0 && !seen.has('duplicate')) {
      seen.add('duplicate');
      messages.push('Duplicate ItemCode combination found.');
    }

    return messages.join(' ');
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setValidatedData(null);
      setInvalidRows([]);
      setDuplicateRows([]);
      setRateErrorRows([]);
      setMissingColumns([]); // reset any previous missing-column error
      setExcelData([]);
      setNotification({
        open: true,
        message: `File "${selectedFile.name}" selected successfully`,
        severity: 'success'
      });
    }
  };

  const handleImport = () => {
    if (!file) {
      setNotification({
        open: true,
        message: 'Please select a file first',
        severity: 'warning'
      });
      return;
    }

    if (isLoadingAreas) {
      setNotification({
        open: true,
        message: 'Please wait for area information to load before importing',
        severity: 'warning'
      });
      return;
    }

    if (areas.length === 0) {
      setNotification({
        open: true,
        message: 'No valid areas found. Please refresh the page or contact support.',
        severity: 'error'
      });
      return;
    }

    setIsLoading(true);
    setInvalidRows([]);
    setDuplicateRows([]);
    setRateErrorRows([]);
    setMissingColumns([]);
    console.log('Import button pressed. File:', file.name);

    // Read the Excel file
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        // Warm the server-date cache so ValidityUpto is checked against the
        // server's business date, not the browser's clock.
        await getServerTodayStr();
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert Excel data to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Check if data exists
        if (jsonData.length === 0) {
          setNotification({
            open: true,
            message: 'No data found in the Excel file',
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }

        // Extract headers from the first row
        const headers = Object.keys(jsonData[0]);
        setExcelColumns(headers);

        // ---- REQUIRED COLUMN CHECK ----
        // Checks AreaCode, ItemCode, Rate, QualifyQty, ValidityUpto.
        // Comparison is case-insensitive and trims stray whitespace in header names.
        const normalizedHeaders = headers.map(h => String(h).trim().toLowerCase());
        const missingBasicColumns = REQUIRED_COLUMNS.filter(
          col => !normalizedHeaders.includes(col.toLowerCase())
        );

        if (missingBasicColumns.length > 0) {
          setMissingColumns(missingBasicColumns);
          setExcelData([]);
          setValidatedData(null);
          setNotification({
            open: true,
            message: `${missingBasicColumns.length > 1 ? 'Columns' : 'Column'} required: ${missingBasicColumns.join(', ')}`,
            severity: 'error'
          });
          setIsLoading(false);
          return;
        }
        // ---- END REQUIRED COLUMN CHECK ----

        setMissingColumns([]);

        // If we reach here, proceed with validation
        processExcelData(jsonData);

      } catch (error) {
        console.error('Error parsing Excel file:', error);
        setNotification({
          open: true,
          message: 'Error parsing the Excel file. Please make sure it is a valid Excel file.',
          severity: 'error'
        });
        setIsLoading(false);
      }
    };

    reader.onerror = () => {
      setIsLoading(false);
      setNotification({
        open: true,
        message: 'Error reading file',
        severity: 'error'
      });
    };

    reader.readAsArrayBuffer(file);
  };

  const processExcelData = (jsonData) => {
    setIsLoading(true);

    // Track invalid rows and duplicate ItemCode combinations
    const invalidRowsList = [];
    const rateErrorRowsList = [];
    const itemCodeCombinations = new Map();
    const duplicateRowsList = [];
    const dataByArea = {};

    // Validate data types and business rules
    const validData = jsonData.map((row, index) => {
      // Define specific error types for more detailed reporting
      const errors = [];
      let sfAreaId = '';

      // Check for AreaCode
      if (!row.AreaCode || row.AreaCode === '') {
        errors.push('missing_areacode');
      } else {
        // Validate AreaCode against available areas from API
        const validAreaCodes = Object.keys(areaCodeToIdMap);
        if (!validAreaCodes.includes(String(row.AreaCode))) {
          errors.push('invalid_areacode');
        } else {
          // Convert AreaCode to sfAreaId
          sfAreaId = areaCodeToIdMap[String(row.AreaCode)];
        }
      }

      // Check for empty values
      if (!row.ItemCode || row.ItemCode === '') {
        errors.push('missing_identifier');
      }

      if (row.Rate === undefined || row.Rate === null || row.Rate === '' ||
        row.QualifyQty === undefined || row.QualifyQty === null || row.QualifyQty === '') {
        errors.push('missing_rate');
      }

      // Check for missing ValidityUpto (now a required column)
      if (row.ValidityUpto === undefined || row.ValidityUpto === null || row.ValidityUpto === '') {
        errors.push('missing_validity');
      } else {
        // Compare against the server's business date (not the browser's clock).
        const rowValidityYYYYMMDD = formatValidTill(row.ValidityUpto);
        const serverTodayYYYYMMDD = getCachedServerTodayStr().replace(/-/g, '');
        if (rowValidityYYYYMMDD && rowValidityYYYYMMDD < serverTodayYYYYMMDD) {
          errors.push('past_validity');
        }
      }

      // Check for negative values
      const rate = Number(row.Rate);
      const qualifyQty = Number(row.QualifyQty);

      if (rate < 0 || qualifyQty < 0) {
        errors.push('negative_value');
      }

      // Check for more than two decimal places in Rate
      if (String(row.Rate).includes('.') && String(row.Rate).split('.')[1].length > 2) {
        errors.push('invalid_decimals');
      }

      // Check for double decimal points
      if (String(row.Rate).split('.').length > 2) {
        errors.push('double_decimal');
      }

      // Check for non-numeric rates or quantities
      if (isNaN(rate) || isNaN(qualifyQty)) {
        errors.push('non_numeric_value');
      }

      // Check for special characters in ItemCode
      if (row.ItemCode && /[^a-zA-Z0-9-_]/.test(row.ItemCode)) {
        errors.push('special_chars');
      }

      // Store error information for this row
      if (errors.length > 0) {
        invalidRowsList.push({
          rowNumber: index + 1,
          errors: errors
        });
      }

      // Check for duplicate ItemCode combinations within same area
      const key = `${sfAreaId}-${row.ItemCode}`;
      if (itemCodeCombinations.has(key)) {
        duplicateRowsList.push(index + 1);
      } else {
        itemCodeCombinations.set(key, index + 1);
      }

      const validRow = {
        AreaCode: String(row.AreaCode || ''),
        AreaId: sfAreaId,
        ItemCode: String(row.ItemCode || ''),
        QualifyQty: qualifyQty,
        Rate: rate,
        ValidityUpto: row.ValidityUpto,
        DML: "I" // Default to Insert
      };

      // Group data by sfAreaId (not AreaCode)
      if (sfAreaId && !errors.length) {
        if (!dataByArea[sfAreaId]) {
          dataByArea[sfAreaId] = [];
        }
        dataByArea[sfAreaId].push({
          ItemCode: String(row.ItemCode || ''),
          QualifyQty: qualifyQty,
          Rate: rate,
          ValidTill: formatValidTill(row.ValidityUpto),
          DML: "I"
        });
      }

      return validRow;
    });

    // Set the validated rows and errors
    setInvalidRowsList(invalidRowsList);
    setInvalidRows(invalidRowsList.map(item => item.rowNumber));
    setRateErrorRows(rateErrorRowsList);
    setDuplicateRows(duplicateRowsList);

    // Calculate all error rows
    const allErrorsRows = [...new Set([...invalidRowsList.map(item => item.rowNumber), ...rateErrorRowsList, ...duplicateRowsList])];

    if (allErrorsRows.length > 0) {
      const errorMessage = buildValidationErrorMessage(invalidRowsList, duplicateRowsList);

      setNotification({
        open: true,
        message: errorMessage,
        severity: 'error'
      });

      // Still set data for display but don't validate for upload
      setExcelData(jsonData);
      if (allErrorsRows.length === jsonData.length) {
        setValidatedData(null); // No valid data to upload
      } else {
        // Filter out invalid entries for upload
        const validatedEntries = validData.filter((_, index) =>
          !allErrorsRows.includes(index + 1)
        );
        setValidatedData(validatedEntries);
      }
    } else {
      setExcelData(jsonData);
      setValidatedData(validData);
      setGroupedDataByArea(dataByArea);

      const areaCount = Object.keys(dataByArea).length;
      setNotification({
        open: true,
        message: `Successfully imported ${jsonData.length} items from ${areaCount} area(s). Ready to upload.`,
        severity: 'success'
      });
    }

    setIsLoading(false);
  };

  const handleUpload = async () => {
    // Check for validation errors before proceeding
    if (!validatedData || validatedData.length === 0) {
      setNotification({
        open: true,
        message: 'Please import and validate data before uploading',
        severity: 'warning'
      });
      return;
    }

    // Check if there are any validation errors
    if (invalidRows.length > 0 || duplicateRows.length > 0 || rateErrorRows.length > 0) {
      setNotification({
        open: true,
        message: 'Please fix all validation errors before uploading',
        severity: 'error'
      });
      return;
    }

    // Check if we have grouped data by area
    if (!groupedDataByArea || Object.keys(groupedDataByArea).length === 0) {
      setNotification({
        open: true,
        message: 'No valid data grouped by area found',
        severity: 'warning'
      });
      return;
    }

    setIsUploading(true);

    try {
      // Convert to IST (UTC+5:30)
      const now = new Date();
      const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
      const istDate = new Date(now.getTime() + istOffset);
      const currentDate = istDate.toISOString();
      const userId = localStorage.getItem('userId') || 'UnknownUser';

      const areaIds = Object.keys(groupedDataByArea);
      let successfulUploads = 0;
      let totalErrors = [];
      let totalSuccessMessages = [];

      // Upload data for each area
      for (const areaId of areaIds) {
        const areaData = groupedDataByArea[areaId];

        const payload = {
          uniqueId: "",
          rebateSchemeType: 'AREA',
          areaId: areaId,
          rebateSchemeId: '',
          customerId: '',
          dateOfEntry: currentDate,
          validFrom: `${FIXED_VALID_FROM_DATE}T23:59:59`,
          createdUserCode: userId,
          ratedetail: areaData.map(row => ({
            itemCode: row.ItemCode,
            qualifyQty: parseFloat(row.QualifyQty) || 0,
            rate: parseFloat(row.Rate) || 0,
            validTill: row.ValidTill || "",
            dml: row.DML || "I"
          }))
        };

        console.log(`Uploading data for AreaID: ${areaId}`, payload);

        try {
          const response = await fetch(`${local_url}/api/CustomerRate`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error(`API response error for area ${areaId}: ${response.status} ${response.statusText}`);
          }

          const result = await response.json();

          // Handle success
          if (result.result === 1 || (result.dbResult && Array.isArray(result.dbResult) && result.dbResult.length > 0)) {
            successfulUploads++;
            const description = result.description || result.dbResult?.[0]?.UniqueId || 'Upload successful';
            totalSuccessMessages.push(`Area ${areaId}: ${description}`);

          }

          // Handle API errors
          if (result.errdescr && Array.isArray(result.errdescr) && result.errdescr.length > 0) {
            const areaErrors = result.errdescr.map(err => ({
              ...err,
              areaId: areaId
            }));
            totalErrors.push(...areaErrors);
          }

        } catch (areaError) {
          console.error(`Error uploading data for area ${areaId}:`, areaError);
          totalErrors.push({
            areaId: areaId,
            itemCode: 'API_ERROR',
            ErrorDescr: areaError.message
          });
        }
      }

      // Set combined API errors for display
      if (totalErrors.length > 0) {
        setApiErrors(totalErrors);
        setShowApiErrorsDialog(true);
      }

      // Show final results
      if (successfulUploads > 0) {
        let message = `Successfully uploaded data for ${successfulUploads} out of ${areaIds.length} area(s).`;
        if (totalErrors.length > 0) {
          message += ` ${totalErrors.length} item(s) had errors.`;
        }

        setNotification({
          open: true,
          message: message,
          severity: totalErrors.length > 0 ? 'warning' : 'success'
        });

        // Clear file only if all areas uploaded successfully
        if (successfulUploads === areaIds.length && totalErrors.length === 0) {
          clearFile();
        }
      } else {
        setNotification({
          open: true,
          message: `Failed to upload data for all ${areaIds.length} area(s).`,
          severity: 'error'
        });
      }

    } catch (error) {
      console.error('Error in upload process:', error);
      setNotification({
        open: true,
        message: `Error in upload process: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsUploading(false);
    }
  };

  const ApiErrorsDialog = () => {
    return (
      <Dialog
        open={showApiErrorsDialog}
        onClose={() => setShowApiErrorsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />
            API Validation Errors
          </Box>
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Area ID</TableCell>
                  <TableCell>Item Code</TableCell>
                  <TableCell>Error Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {apiErrors.map((error, index) => (
                  <TableRow key={index}>
                    <TableCell>{error.areaId || '-'}</TableCell>
                    <TableCell>{error.itemCode}</TableCell>
                    <TableCell>{error.ErrorDescr}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowApiErrorsDialog(false)}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleDownloadSample = () => {
    // Filter out PLANT and RETAIL from available areas
    const excludedAreaCodes = ['PLANT', 'RETAIL'];
    const validAreas = areas.filter(area => !excludedAreaCodes.includes(area.AreaCode));

    if (validAreas.length === 0) {
      setNotification({
        open: true,
        message: 'No valid areas available for sample data',
        severity: 'warning'
      });
      return;
    }

    // Generate sample data for each valid area
    const sampleData = [];
    const sampleItems = [
      { code: '71001211', rate: 51, qty: 20 },
      { code: '71001213', rate: 120, qty: 41 },
      { code: '71001212', rate: 130, qty: 140 }
    ];

    validAreas.forEach((area, areaIndex) => {
      // Add 2-3 sample items for each area
      const itemsForArea = sampleItems.slice(0, Math.min(2 + (areaIndex % 2), sampleItems.length));
      itemsForArea.forEach(item => {
        sampleData.push({
          AreaCode: area.AreaCode,
          ItemCode: item.code,
          Rate: item.rate,
          QualifyQty: item.qty,
          ValidityUpto: '20261231'
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sample Data');

    XLSX.writeFile(workbook, 'HorecaUpload_Sample.xlsx');

    setNotification({
      open: true,
      message: 'Sample Excel file downloaded successfully',
      severity: 'success'
    });
  };

  const clearFile = () => {
    setFile(null);
    setFileName('');
    setExcelData([]);
    setValidatedData(null);
    setInvalidRows([]);
    setDuplicateRows([]);
    setRateErrorRows([]);
    setGroupedDataByArea({});
    setMissingColumns([]);

    // Reset the file input value if the ref is available
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  // Helper function to determine row styling based on validation errors
  const getRowStyle = (index) => {
    const rowNum = index + 1;
    const isInvalidFormat = invalidRows.includes(rowNum);
    const isDuplicate = duplicateRows.includes(rowNum);
    const hasRateError = rateErrorRows.includes(rowNum);

    if (isInvalidFormat || isDuplicate || hasRateError) {
      return {
        backgroundColor: '#ffebee',
        '&:hover': { backgroundColor: '#ffcdd2' }
      };
    }

    return {
      '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
      '&:hover': { backgroundColor: '#f5f5f5' }
    };
  };

  // Helper function to get error tooltip message for a row
  const getRowErrorMessage = (index) => {
    const rowNum = index + 1;
    const errors = [];

    // Find specific error types for this row
    const invalidRow = invalidRowsList.find(item => item.rowNumber === rowNum);
    if (invalidRow) {
      if (invalidRow.errors.includes('missing_areacode')) errors.push("Missing AreaCode");
      if (invalidRow.errors.includes('invalid_areacode')) errors.push("Invalid AreaCode (not found in system)");
      if (invalidRow.errors.includes('missing_identifier')) errors.push("Missing ItemCode");
      if (invalidRow.errors.includes('missing_rate')) errors.push("Missing Rate or QualifyQty");
      if (invalidRow.errors.includes('missing_validity')) errors.push("Missing ValidityUpto");
      if (invalidRow.errors.includes('past_validity')) errors.push("ValidityUpto cannot be less than today's date");
      if (invalidRow.errors.includes('negative_value')) errors.push("Negative value");
      if (invalidRow.errors.includes('invalid_decimals')) errors.push("More than 2 decimal places in Rate");
      if (invalidRow.errors.includes('special_chars')) errors.push("Special characters in ItemCode");
      if (invalidRow.errors.includes('double_decimal')) errors.push("Double decimal point");
      if (invalidRow.errors.includes('non_numeric_value')) errors.push("Non-numeric value");
    }

    if (duplicateRows.includes(rowNum)) {
      errors.push("Duplicate ItemCode");
    }

    return errors.join(", ");
  };

  return (
    <>
      {!embedded && <Header />}
      <ThemeProvider theme={theme}>
        <Box sx={embedded ? { backgroundColor: 'background.default' } : {
          minHeight: '100vh',
          backgroundColor: 'background.default',
          py: 1,
          overflow: 'auto',
          maxHeight: '100vh'
        }}>
          <Container maxWidth="lg" sx={{ py: 1, height: '100%', overflow: 'auto' }}>
            <Grow in={true} timeout={800}>
              <Paper elevation={embedded ? 0 : 3} sx={{ p: 2, borderRadius: 2, overflow: 'auto', maxHeight: embedded ? 'none' : 'calc(100vh - 120px)', position: 'relative' }}>
                {embedded && onClose && (
                  <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      zIndex: 1,
                      backgroundColor: 'rgba(0,0,0,0.04)',
                      '&:hover': { backgroundColor: 'rgba(0,0,0,0.08)' }
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
                {!embedded && (
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1,
                    borderBottom: '1px solid #e0e0e0',
                    pb: 1
                  }}>
                    <TableChartIcon sx={{ fontSize: 28, mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h5" component="h1">
                      Area Rate Upload
                    </Typography>
                    <Tooltip title="Upload Excel files with AreaCode, ItemCode, Rate, QualifyQty and ValidityUpto columns">
                      <IconButton sx={{ ml: 1.5 }} size="small">
                        <InfoIcon color="action" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}

                <Box sx={{
                  backgroundColor: '#f8faff',
                  p: 2,
                  borderRadius: 2,
                  mb: 1,
                  border: '1px solid #e3f2fd'
                }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
                    Upload Excel Data
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
                        <Button
                          variant="contained"
                          component="label"
                          startIcon={<FileOpenIcon />}
                          sx={{
                            py: 1,
                            px: 2,
                            background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                            boxShadow: '0 2px 4px 1px rgba(33, 203, 243, .3)',
                            color: 'white',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                              background: 'linear-gradient(45deg, #1976d2 30%, #21a6f3 90%)',
                            }
                          }}
                        >
                          Choose File
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx, .xls"
                            hidden
                            onChange={handleFileChange}
                          />
                        </Button>

                        <Button
                          variant="outlined"
                          startIcon={<DownloadIcon />}
                          onClick={handleDownloadSample}
                          sx={{
                            py: 1,
                            px: 2,
                            borderColor: '#4caf50',
                            color: '#4caf50',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                              borderColor: '#388e3c',
                              color: '#388e3c',
                              backgroundColor: 'rgba(76, 175, 80, 0.04)',
                            }
                          }}
                        >
                          Download Sample
                        </Button>

                        {fileName && (
                          <Fade in={!!fileName}>
                            <Chip
                              label={fileName}
                              variant="outlined"
                              color="primary"
                              onDelete={clearFile}
                              deleteIcon={<DeleteIcon />}
                              sx={{ maxWidth: '250px' }}
                            />
                          </Fade>
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleImport}
                        disabled={!file || isLoading}
                        fullWidth
                        sx={{
                          py: 1,
                          background: file && !isLoading ? 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)' : '',
                          boxShadow: file && !isLoading ? '0 2px 4px 1px rgba(76, 175, 80, .3)' : '',
                          '&:hover': {
                            background: file && !isLoading ? 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)' : ''
                          }
                        }}
                      >
                        {isLoading ? (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                            Processing...
                          </Box>
                        ) : (
                          <>
                            <CloudUploadIcon sx={{ mr: 1 }} /> Validate Data
                          </>
                        )}
                      </Button>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleUpload}
                        disabled={
                          !validatedData ||
                          isUploading ||
                          invalidRows.length > 0 ||
                          duplicateRows.length > 0 ||
                          rateErrorRows.length > 0 ||
                          !groupedDataByArea ||
                          Object.keys(groupedDataByArea).length === 0
                        }
                        fullWidth
                        sx={{
                          py: 1,
                          background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
                            'linear-gradient(45deg, #FF5722 30%, #FF9800 90%)' : '',
                          boxShadow: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
                            '0 2px 4px 1px rgba(255, 87, 34, .3)' : '',
                          '&:hover': {
                            background: validatedData && !isUploading && invalidRows.length === 0 && duplicateRows.length === 0 && rateErrorRows.length === 0 && groupedDataByArea && Object.keys(groupedDataByArea).length > 0 ?
                              'linear-gradient(45deg, #E64A19 30%, #F57C00 90%)' : ''
                          }
                        }}
                      >
                        {isUploading ? (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                            Uploading...
                          </Box>
                        ) : (
                          <>
                            <SendIcon sx={{ mr: 1 }} /> Submit
                          </>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ mt: 1 }}>
                  <Typography variant="h6" sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}>
                    <TableChartIcon sx={{ mr: 1, fontSize: 18 }} /> Data Preview
                  </Typography>

                  {excelData.length > 0 ? (
                    <Fade in={excelData.length > 0} timeout={800}>
                      <TableContainer component={Paper} sx={{
                        mt: 1,
                        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                        borderRadius: 1.5,
                        maxHeight: 350,
                        overflow: 'auto'
                      }}>
                        <Table aria-label="excel data table" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Row</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>Area Code</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>Item Code</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Rate</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Qualify Qty</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 'bold' }}>Validity Upto</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 'bold' }}>Status</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {excelData.map((row, index) => {
                              const rowNum = index + 1;
                              const hasError = invalidRows.includes(rowNum) ||
                                duplicateRows.includes(rowNum);
                              const errorMsg = getRowErrorMessage(index);

                              return (
                                <TableRow
                                  key={index}
                                  sx={getRowStyle(index)}
                                >
                                  <TableCell>{rowNum}</TableCell>
                                  <TableCell>{row.AreaCode || '-'}</TableCell>
                                  <TableCell>{row.ItemCode}</TableCell>
                                  <TableCell align="right">
                                    {typeof row.Rate === 'number'
                                      ? `${row.Rate.toFixed(2)}`
                                      : row.Rate}
                                  </TableCell>
                                  <TableCell align="right">
                                    {typeof row.QualifyQty === 'number'
                                      ? `${row.QualifyQty}`
                                      : row.QualifyQty}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.ValidityUpto
                                      ? formatValidTill(row.ValidityUpto)
                                      : <span style={{ color: '#bdbdbd' }}>-</span>}
                                  </TableCell>
                                  <TableCell align="center">
                                    {hasError ? (
                                      <Tooltip title={errorMsg}>
                                        <ErrorOutlineIcon color="error" />
                                      </Tooltip>
                                    ) : (
                                      <Chip
                                        label="Valid"
                                        size="small"
                                        color="success"
                                        variant="outlined"
                                        sx={{ fontSize: '0.7rem' }}
                                      />
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fade>
                  ) : (
                    <Fade in={!excelData.length} timeout={800}>
                      <Box
                        sx={{
                          p: 3,
                          textAlign: 'center',
                          bgcolor: '#fafafa',
                          borderRadius: 2,
                          border: '2px dashed #e0e0e0',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <CloudUploadIcon sx={{ fontSize: 48, color: '#bdbdbd', mb: 1.5 }} />
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 0.5 }}>
                          No Data Available
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Upload an Excel file to view your data here
                        </Typography>
                      </Box>
                    </Fade>
                  )}
                </Box>

                {validatedData && validatedData.length > 0 && (
                  <Box sx={{ mt: 2, p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1.5, border: '1px solid #c8e6c9' }}>
                    <Typography variant="subtitle1" sx={{ color: '#2e7d32', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                      <InfoIcon sx={{ mr: 0.5, fontSize: 18 }} />
                      Data validated successfully. {validatedData.length} valid records ready to upload.
                      {invalidRows.length > 0 || duplicateRows.length > 0 ?
                        ` (${invalidRows.length + duplicateRows.length} invalid records will be skipped)` :
                        ''}
                    </Typography>
                  </Box>
                )}

                {apiErrors.length > 0 && (
                  <Box sx={{ mt: 2, p: 1.5, bgcolor: '#fff3e0', borderRadius: 1.5, border: '1px solid #ffe0b2' }}>
                    <Typography variant="subtitle1" sx={{ color: '#e65100', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                      <ErrorOutlineIcon sx={{ mr: 0.5, fontSize: 18 }} />
                      {apiErrors.length} items failed validation during upload.
                      <Button
                        color="warning"
                        variant="outlined"
                        size="small"
                        onClick={() => setShowApiErrorsDialog(true)}
                        sx={{ ml: 1.5, fontSize: '0.75rem', py: 0.5 }}
                      >
                        View Errors
                      </Button>
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grow>
          </Container>
        </Box>

        <FloatingToast
          open={notification.open}
          message={notification.message}
          severity={notification.severity}
          onClose={handleCloseNotification}
        />

        {/* ColumnMismatchDialog component */}
        <Dialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <InfoIcon color="primary" sx={{ mr: 1 }} />
              Confirm Upload
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              You are about to upload {validatedData ? validatedData.length : 0} HORECA rate records.
              {invalidRows.length > 0 || duplicateRows.length > 0 ?
                ` ${invalidRows.length + duplicateRows.length} invalid records will be skipped.` : ''}
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              Do you want to proceed?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowConfirmDialog(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setShowConfirmDialog(false);
                handleUpload();
              }}
              color="primary"
              variant="contained"
              startIcon={<SendIcon />}
            >
              Proceed
            </Button>
          </DialogActions>
        </Dialog>

        <ApiErrorsDialog />
      </ThemeProvider>
    </>
  );
};

export default HorecaUpload;
